import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearTimes, storeUser } from "../../Redux/Slice/authSlice";
import { LogotAction } from "../../Redux/Action/AuthAction";
import { msalInstance } from "../../Util/msalConfig";
import { clearPlatformVisitMarkers } from "../../Util/visitTracking";
import {
  formatOrganisationRole,
  getOrganisationGroupRole,
  getOrganisationRoleAccess,
} from "../utils/roleAccess";

export default function OrganisationGroupsSettings() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const organisationGroup = userData?.organisationGroupId;
  const access = getOrganisationRoleAccess(userData);

  const logoutFunc = async () => {
    try {
      await dispatch(LogotAction());
    } catch (error) {}

    try {
      sessionStorage.clear();
      msalInstance.clearCache();
    } catch (error) {}

    clearPlatformVisitMarkers();
    localStorage.removeItem("token");
    dispatch(clearTimes());
    dispatch(storeUser(null));
    window.location.href = "/";
  };

  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Your Account</p>
          <h2>Organisation Settings</h2>
        </div>

        <Row className="g-4 mt-1">
          <Col xl={5} lg={12}>
            <div className="cmn-card-color organisation-profile-card">
              <div className="student-view">
                <img
                  src={userData?.image || require("../../Assets/Images/girl.png")}
                  alt="Organisation profile"
                />
                <h2>
                  {[userData?.firstName, userData?.surName].filter(Boolean).join(" ") ||
                    "Organisation Group User"}
                </h2>
                <p>{organisationGroup?.name || "Organisation Group Module"}</p>
                <p>{formatOrganisationRole(getOrganisationGroupRole(userData))}</p>
              </div>

              <div className="organisation-profile-grid">
                <div>
                  <span>Email</span>
                  <strong>{userData?.email || "Not available"}</strong>
                </div>
                <div>
                  <span>Phone</span>
                  <strong>{organisationGroup?.phoneNumber || "Not set"}</strong>
                </div>
                <div>
                  <span>Address</span>
                  <strong>{organisationGroup?.address || "Not available"}</strong>
                </div>
                <div>
                  <span>Postcode</span>
                  <strong>{organisationGroup?.postcode || "Not set"}</strong>
                </div>
              </div>
            </div>
          </Col>

          <Col xl={7} lg={12}>
            <div className="cmn-card-color organisation-actions-card">
              <div className="organisation-panel-heading">
                <div>
                  <h3>Account actions</h3>
                </div>
              </div>

              <div className="organisation-action-grid">
                {access.canViewSchoolDetails && (
                  <Link to="/organisations/school-details" className="cmn-pink">
                    School Details
                  </Link>
                )}
                <Link to="/organisations/update-password" className="cmn-pink">
                  Update Password
                </Link>
                <Link
                  to="https://peerscroller.com/legal"
                  className="cmn-pink"
                  target="_blank"
                >
                  Legal
                </Link>
              </div>

              <div className="organisation-note-banner organisation-note-banner-inline">
                Your account currently has{" "}
                <strong>{access.roleLabel.toLowerCase()}</strong> access within
                this organisation group.
              </div>

              <button
                type="button"
                className="cmn-pink organisation-logout-btn"
                onClick={logoutFunc}
              >
                Logout
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
